import { useNavigationHelper, useTargetBrandConfig } from 'FrontRoyalAngular';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { BasicDesktopBox } from '../../BasicDesktopBox';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';

function OurDegreeProgramsBoxComponent() {
    const { t } = useTranslation('back_royal', { keyPrefix: 'ourDegreeProgramsBox' });
    const brandConfig = useTargetBrandConfig();
    const { loadUrl } = useNavigationHelper();
    const buttons = useMemo(() => {
        if (!brandConfig?.ourDegreeProgramsSidebarBoxButtons) return [];
        return [
            {
                id: 'button_the_mba',
                text: t('button_the_mba'),
                onPress: () => loadUrl(brandConfig.learnMoreAboutMbaUrl, '_blank'),
            },
            {
                id: 'button_the_executive_mba',
                text: t('button_the_executive_mba'),
                onPress: () => loadUrl(brandConfig.learnMoreAboutEmbaUrl, '_blank'),
            },
            {
                id: 'button_msba',
                text: t('button_msba'),
                onPress: () => loadUrl(brandConfig.learnMoreAboutMsbaUrl, '_blank'),
            },
            {
                id: 'button_msse',
                text: t('button_msse'),
                onPress: () => loadUrl(brandConfig.learnMoreAboutMsseUrl, '_blank'),
            },
            {
                id: 'button_msaie',
                text: t('button_msaie'),
                onPress: () => loadUrl(brandConfig.learnMoreAboutMsaieUrl, '_blank'),
            },
        ].filter(button => brandConfig.ourDegreeProgramsSidebarBoxButtons.includes(button.id)) as ButtonConfig[];
    }, [brandConfig, loadUrl, t]);

    return <OurDegreeProgramsBoxPresentation buttons={buttons} institutionName={brandConfig.brandNameShort} />;
}

function OurDegreeProgramsBoxPresentation({
    buttons,
    institutionName,
}: {
    buttons: ButtonConfig[];
    institutionName: string;
}) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'ourDegreeProgramsBox' });
    return (
        <BasicDesktopBox headerText={t('heading')} buttons={buttons} boxKey={SidebarBoxKey.our_degree_programs}>
            {t('content', { institutionName })}
        </BasicDesktopBox>
    );
}

export const OurDegreeProgramsBox = memo(OurDegreeProgramsBoxComponent);
